export const downloadFile = (url: string, fileName: string) => {
  try {
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error(error);
  }
};

/**
 * Fetches a file from the given URL and triggers a browser download with the specified file name.
 * Used for export flows that return a downloadUrl + fileName (e.g. Company ExportTree).
 */
export async function downloadFileFromUrl(
  downloadUrl: string,
  fileName: string
): Promise<void> {
  const response = await fetch(downloadUrl);
  const blob = await response.blob();
  const fileLink = document.createElement('a');
  fileLink.href = URL.createObjectURL(blob);
  fileLink.download = fileName;
  document.body.appendChild(fileLink);
  fileLink.click();
  document.body.removeChild(fileLink);
  URL.revokeObjectURL(fileLink.href);
}

export const exportToTextFile = <T,>(data: T[], fileName: string) => {
  const jsonString = JSON.stringify(data, null, 2);
  const blob = new Blob([jsonString], { type: 'text/plain' });
  const url = window.URL.createObjectURL(blob);
  downloadFile(url, fileName);
};

export async function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export const readFileAsArrayBuffer = (file: File) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = (error) => {
      reject(error);
    };
    reader.readAsArrayBuffer(file);
  });

export const uint8ArrayToBase64 = (uint8Array: Uint8Array): string => {
  if (typeof Buffer !== 'undefined') {
    // Use Buffer in Node.js environment
    return Buffer.from(uint8Array).toString('base64');
  } else {
    // Use btoa in the browser
    let binary = '';
    uint8Array.forEach((byte) => (binary += String.fromCharCode(byte)));
    return btoa(binary);
  }
};

export const base64ToArrayBuffer = (base64String: string): ArrayBuffer => {
  const binaryString = atob(base64String);
  const len = binaryString.length;
  const arrayBuffer = new ArrayBuffer(len);

  // Create a typed array view (Uint8Array) to access the buffer
  const uint8Array = new Uint8Array(arrayBuffer);

  // Populate the Uint8Array with the binary data
  for (let i = 0; i < len; i++) {
    uint8Array[i] = binaryString.charCodeAt(i);
  }

  return arrayBuffer;
};
